import { render, staticRenderFns } from "./Authentication.vue?vue&type=template&id=2d2d3ace&scoped=true&"
import script from "./Authentication.js?vue&type=script&lang=js&"
export * from "./Authentication.js?vue&type=script&lang=js&"
import style0 from "./Authentication.scss?vue&type=style&index=0&id=2d2d3ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2d3ace",
  null
  
)

export default component.exports